import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CnafUserService } from '@cnaf/ng-cnaf-commons';
import { ConstantePage } from '../constants/constante-page';
import { TagWaService } from '../services/tag-wa.service';

  @Component({
    selector: 'app-preparation',
    templateUrl: './preparation.component.html',
    styleUrls: ['./preparation.component.css']
  })
  export class PreparationComponent implements OnInit {  
  
  pageName = ConstantePage.STATS_PAGE_ACCUEIL_NON_AUTHENTIFIE;
  chapter3Page = ConstantePage.STATS_CHAPTER3_PAGE_ACCUEIL;

  /**
   * Constructor
   * 
   * @param router 
   * @param cnafUserService 
   * @param tagWaService 
   */
  constructor(
    private readonly router: Router,
    private readonly cnafUserService: CnafUserService,
    private readonly tagWaService: TagWaService
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit() {

     // On verifie si l'usager est authentifié pour modifier changer si besoin le nom de la page taguée 
    // pour le Web-Analytic de "Non authentifié" à "Allocataire".
    const codeOrga = this.cnafUserService.codeOrga;
    const matricule = this.cnafUserService.matricule;
    const dateEnvCaffr = this.cnafUserService.dateEnvCaffr;
    if (dateEnvCaffr !== undefined) {
      if (matricule !== undefined && matricule !== '' && codeOrga !== undefined && codeOrga !== '' ) {
        this.pageName = ConstantePage.STATS_PAGE_ACCUEIL_ALLOCATAIRE;        
      }
    }

    // On tague la page pour le WA
    this.tagWaService.tagPage(this.pageName, this.chapter3Page);

    //  On purge le session storage
    sessionStorage.removeItem(ConstantePage.STATS_PAGE_DECLARATION);
    sessionStorage.removeItem(ConstantePage.STATS_PAGE_DECLARATION_ENFANT);
  }

  /**
   * Click Suivant
   */
  clickSuivant() : void {
    this.router.navigate(['/declaration']);
  }
}
